module.exports = __webpack_public_path__ + "img/grid-srp-preview-infiniti.27163113.png";